// Funzioni per ottenere i timestamp di inizio e fine mese
export function getFirstTimestampOfMonth() {
    let now = new Date();
    let firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    return Math.floor(firstDayOfMonth.getTime() / 1000);
}


export function getLastTimestampOfMonth() {
    let now = new Date();
    let firstDayOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    let lastDayOfMonth = new Date(firstDayOfNextMonth.getTime() - 1);
    return Math.floor(lastDayOfMonth.getTime() / 1000);
}
